<spoerreundersoekelse-liste [gruppeId]="gruppe().id"/>

<gruppe-moeteevalueringer [gruppe]="gruppe()"/>
